import randomstring from "randomstring";

type Opt =
  | {
      length: number;
    }
  | {
      minLength: number;
      maxLength: number;
    };

export const generateAlphaNumericRandomStr = (opt: Opt): string => {
  return randomstring.generate({
    length: getLength(opt),
    charset: "alphanumeric",
  });
};

const getLength = (opt: Opt): number => {
  if ("length" in opt) {
    return opt.length;
  }

  return getRandomInt(opt.minLength, opt.maxLength);
};

// https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Math/random#getting_a_random_integer_between_two_values_inclusive
const getRandomInt = (min: number, max: number): number => {
  const minInt = Math.ceil(min);
  const maxInt = Math.floor(max);
  return Math.floor(Math.random() * (minInt - maxInt + 1) + maxInt);
};
